import buttonActive from "../../../assets/sounds/effects/ButtonActive.mp3";
import { useSound } from "./useSound";

export const soundButtonActive = () => {
  const sound = useSound({src:buttonActive});

  sound.play();
};
